var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Fragment',[_c('tr',{class:{ 'TileData__highlighted': _vm.highlight }},[_c('td',{attrs:{"colspan":"3"}},[_c('strong',[_vm._t("header")],2)])]),_vm._t("default"),_c('br')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }